// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"lk","modalBox":"lk","modal-mask":"ll","modalMask":"ll","close-btn":"lm","closeBtn":"lm","container":"ln","content":"lo","title":"lp","subTitle":"lq","detail":"lr"};